// extracted by mini-css-extract-plugin
export default {"codePanel":"_1Biib8rKG8vSSv7etcd0f1"};